export const firebaseConfig = {
    apiKey: "AIzaSyAd2mRiJge7nZi5ONMQn3BdpYLbOdVENws",
    authDomain: "madeforme-40d4c.firebaseapp.com",
    projectId: "madeforme-40d4c",
    storageBucket: "madeforme-40d4c.appspot.com",
    messagingSenderId: "179802770033",
    appId: "1:179802770033:web:8cbec3b395d3cd4fb9a9d0"
  };

  